import React, { useEffect, useState } from 'react';
import { Button } from '..';

import './styles.css';
import icPlay from '../../assets/ic-play.svg';
import icDate from '../../assets/ic-date.svg';
import icClock from '../../assets/ic-clock.svg';
import avatar from '../../assets/dummy/avatar.svg';

import MediaPlayer from '../MediaPlayer/MediaPlayer';
import { useDispatch, useSelector } from 'react-redux';
import { getPlaylistItems } from '../../redux/actions/playlist';
import { getMediaInfo } from '../../redux/actions/media';
import { useHistory } from 'react-router-dom';
import { authPopup } from '../../redux/actions/auth';
import {
  formatDateV2,
  formatSecsDuration,
  generateSelectChannelURL,
} from '../../utils';

const ContentLiveDetailTop = ({ item, handleClickDetail }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [playVideo, setPlayVideo] = useState(false);
  const [mediaDetail, setMediaDetail] = useState();
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    const getEpisode = async () => {
      const detailData = await dispatch(getMediaInfo(item.id, item.type));

      if (detailData && detailData.items && detailData.items.length) {
        const mediaId = detailData.items[0].id;
        const episodes = await dispatch(getPlaylistItems(mediaId, 1, 10));

        setMediaDetail(episodes.data[0]);
      }
    };

    if (item.type === 'series') {
      getEpisode();
    } else {
      setMediaDetail(item);
    }
  }, [dispatch, item]);

  const handleClickWatch = () => {
    if (item.premium && !token) {
      return dispatch(authPopup.show());
    }

    if (item.type === 'live') {
      history.push(`/live-show/${item.latestShow.id}`);
      return;
    }

    const channelURL = generateSelectChannelURL(item);
    history.push(channelURL);
    setPlayVideo(true);
  };

  return (
    <>
      <div className='item-detail'>
        <div className='red-dot'>
          <p>Live</p>
        </div>
        <div className='title-banner' onClick={handleClickDetail}>
          <span>{item.title}</span>
        </div>
        <div className='content-details'>
          <img src={icDate} alt='icon' width={16} height={16} />
          <span className='date'>{formatDateV2(item.startedAt)}</span>
          <img src={icClock} alt='icon' width={16} height={16} />
          <span className='time'>
            {formatSecsDuration(item.startedAt / 1000, {
              format: 'hh mm',
              delimiter: ':',
            })}
          </span>
        </div>
        <div className='description-img' onClick={handleClickDetail}>
          <div className='wrapper-image-avatar'>
            <div className='border-image-avatar'>
              <img
                src={item?.profile?.avatar ? item.profile.avatar : avatar}
                alt='avatar'
              />
            </div>
          </div>
          {item.profile.name}
        </div>
        <div className='content-actions'>
          <Button
            icon={icPlay}
            iconStyle={{
              width: 40,
              height: 40,
              backgroundColor: '#F49832',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '50%',
            }}
            shape='rounded'
            fontSize={16}
            size='large'
            style={{
              width: '224px',
              height: '40px',
              background: '#F49832',
              borderRadius: '1000px',
            }}
            onClick={handleClickWatch}
          >
            Watch Now
          </Button>
        </div>
      </div>

      {playVideo && mediaDetail && (
        <MediaPlayer
          mediaType={mediaDetail.type}
          mediaId={mediaDetail.id}
          autoPlay={true}
          onClose={() => setPlayVideo(false)}
        />
      )}
    </>
  );
};

export default ContentLiveDetailTop;
